export const brandLight = [
    "#e9ecef",
    "#dee2e6",
    "#ced4da",
    "#adb5bd",
    "#868e96",
    "#495057",
    "#212529", // Index 6: Black in light mode
    "#1a1c1e",
    "#121416",
    "#0a0b0c"
] as const;

export const brandDark = [
    "#0a0b0c",
    "#121416",
    "#1a1c1e",
    "#212529",
    "#495057",
    "#868e96",
    "#ced4da", // Index 6: Light Gray in dark mode
    "#adb5bd",
    "#dee2e6",
    "#e9ecef"
] as const;

export const black = [
    "#adb5bd",
    "#868e96",
    "#495057",
    "#343a40",
    "#212529",
    "#1b1e21",
    "#16191d", // Index 6: Solid dark black
    "#0d0f12",
    "#050505",
    "#000000"
] as const;
